import React, { useState } from "react";

const images = [
  "/mobilhaz_g1.png",
  "/mobilhaz_g2.png",
  "/mobilhaz_g3.png",
  "/mobilhaz_g4.png",
  "/mobilhaz_g5.png"
];

import { useLanguage } from "../LanguageProvider";

export default function GallerySection() {
  const [selected, setSelected] = useState(null);
  const { dict } = useLanguage();
  const gallery = dict.gallery || {};
  return (
    <section className="py-20 bg-section">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-8 text-center tracking-tight">
          {gallery.sectionTitle || "Galéria"}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {images.map((src, i) => (
            <button key={i} className="group relative" onClick={() => setSelected(src)}>
              <img src={src} alt={`${gallery.imageAlt || "Galéria"} ${i+1}`} className="rounded-modulive shadow-lg object-cover w-full h-40 md:h-56 border-2 border-transparent group-hover:border-secondary transition" />
              <span className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition rounded-2xl"></span>
            </button>
          ))}
        </div>
        {selected && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80" onClick={() => setSelected(null)}>
            <img src={selected} alt={gallery.modalAlt || "Nagyított kép"} className="max-h-[80vh] max-w-[90vw] rounded-modulive shadow-glow-turquoise border-2 border-secondary" />
          </div>
        )}
      </div>
    </section>
  );
}
